import React, { useEffect, useState } from "react";
import LightGallery from "lightgallery/react";
import "lightgallery/css/lightgallery.css";
import { LightGalleryKeyString } from "../../constants/LightGalleryKey";
import {
  Star,
  StarFill,
  StarHalf,
  BrowserEdge,
  Envelope,
  Facebook,
  Instagram,
  Linkedin,
  TelephoneFill,
  Tiktok,
  Twitter,
} from "react-bootstrap-icons";
import NoImagePlaceholder from "../../assets/NoImagePlaceholder.png";
import Reviews from "./Reviews";
import { Dropdown } from "react-bootstrap";
import UploadProfilePictureModal from "./modals/UploadProfilePictureModal";
import DeleteProfilePictuteModal from "./modals/DeleteProfilePictuteModal";
import ClubImageModal from "./modals/ClubImageModal";
import ProfileImgModal from "./modals/ProfileImgModal";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function BasicClubInfo({ id }) {
  const [mainImages, setMainImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [images, setImages] = useState([]);
  const [rating, setRating] = useState([]);
  const [showReviews, setShowReviews] = useState(false);
  const [uploadProfilePictureModal, setUploadProfilePicModal] = useState(false);
  const [deleteProfileImageModal, setDeleteProfileImageModal] = useState(false);
  const [profileImgModal, setProfileImgModal] = useState(false);
  const [club, setClub] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [imgModal, setImgModal] = useState(false);



  //PremclubObject

  const { user, dispatch } = useAuthContext();
  const navi = useNavigate();

  const formatDateWithSuffix = (dateString) => {
    const date = new Date(dateString);
    const options = { year: "numeric", month: "long" };
    return date.toLocaleDateString();
  };

  const calculateAverageRating = () => {
    if (rating.length === 0) return 0;

    const totalStars = rating.reduce((sum, review) => sum + review.stars, 0);
    return totalStars / rating.length;
  };

  const averageRating = calculateAverageRating();
  const totalReviews = rating.length;
  const fullStars = Math.floor(averageRating);
  const hasHalfStar = averageRating % 1 >= 0.5;
  const fetchData = async () => {
    setIsLoading(true); // Start loading

    try {
      // Fetch club info
      const clubResponse = await axios.get(
        `${ApiConnectionString}/api/myclub/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      setClub(clubResponse.data);
      const ratingResoponse = await axios.get(
        `${ApiConnectionString}/api/Rating/${id}`
      );
      setRating(ratingResoponse.data);

      const imageResponse = await axios.get(
        `${ApiConnectionString}/api/images?ClubId=${id}&ClubImage=true`
      );
      const orderedImages = imageResponse.data.sort(
        (a, b) => a.clubImageIndex - b.clubImageIndex
      );

      setImages(orderedImages);
      // setMainImages(imageResponse.data.filter((image) => image.mainImage));
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("An error occurred while fetching data:", error);
      // Optionally, you can set an error state here to display an error message to the user
    } finally {
      setIsLoading(false); // Stop loading regardless of success or failure
    }
  };
  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [id, user]);

  const readableDate = formatDateWithSuffix(club.created);

  const cancelModal = () => {
    setUploadProfilePicModal(false);
    setDeleteProfileImageModal(false);
    setProfileImgModal(false);
    setImgModal(false);
  };
  const closeReviews = () => {
    setShowReviews(false);
  };

  const renderLayout = () => {
    if (images.length === 1) {
      return (
        <LightGallery
          licenseKey={LightGalleryKeyString}
          selector=".lightgallery-item"
        >
          <div className="row g-2">
            <div className="col-12">
              <a
                href={`${ApiConnectionString}/api/Image/${images[0].id}`}
                className="lightgallery-item"
              >
                <img
                  src={`${ApiConnectionString}/api/Image/${images[0].id}`}
                  alt="Club"
                  className="img-fluid rounded border w-100"
                  style={{ aspectRatio: "1/1", objectFit: "cover" }}
                />
              </a>
            </div>
          </div>
        </LightGallery>
      );
    }

    if (images.length === 2) {
      return (
        <LightGallery
          licenseKey={LightGalleryKeyString}
          selector=".lightgallery-item"
        >
          <div className="row g-2">
            {images.map((img) => (
              <div className="col-12" key={img.id}>
                <a
                  href={`${ApiConnectionString}/api/Image/${img.id}`}
                  className="lightgallery-item"
                >
                  <img
                    src={`${ApiConnectionString}/api/Image/${img.id}`}
                    alt="Club"
                    className="img-fluid rounded border w-100"
                    style={{ aspectRatio: "1/1", objectFit: "cover" }}
                  />
                </a>
              </div>
            ))}
          </div>
        </LightGallery>
      );
    }

    if (images.length === 3) {
      return (
        <LightGallery
          licenseKey={LightGalleryKeyString}
          selector=".lightgallery-item"
        >
          <div className="row g-2">
            <div className="col-12">
              <a
                href={`${ApiConnectionString}/api/Image/${images[0].id}`}
                className="lightgallery-item"
              >
                <img
                  src={`${ApiConnectionString}/api/Image/${images[0].id}`}
                  alt="Club"
                  className="img-fluid rounded border w-100"
                  style={{ aspectRatio: "1/1", objectFit: "cover" }}
                />
              </a>
            </div>

            {images.slice(1).map((img) => (
              <div className="col-6" key={img.id}>
                <a
                  href={`${ApiConnectionString}/api/Image/${img.id}`}
                  className="lightgallery-item"
                >
                  <img
                    src={`${ApiConnectionString}/api/Image/${img.id}`}
                    alt="Club"
                    className="img-fluid rounded border w-100"
                    style={{ aspectRatio: "1/1", objectFit: "cover" }}
                  />
                </a>
              </div>
            ))}
          </div>
        </LightGallery>
      );
    }

    if (images.length === 4) {
      return (
        <LightGallery
          licenseKey={LightGalleryKeyString}
          selector=".lightgallery-item"
        >
          <div className="row g-2">
            {images.map((img) => (
              <div className="col-6" key={img.id}>
                <a
                  href={`${ApiConnectionString}/api/Image/${img.id}`}
                  className="lightgallery-item"
                >
                  <img
                    src={`${ApiConnectionString}/api/Image/${img.id}`}
                    alt="Club"
                    className="img-fluid rounded border w-100"
                    style={{ aspectRatio: "1/1", objectFit: "cover" }}
                  />
                </a>
              </div>
            ))}
          </div>
        </LightGallery>
      );
    }

    return (
      <LightGallery
        licenseKey={LightGalleryKeyString}
        selector=".lightgallery-item"
      >
        <div className="row g-2">
          {images.map((img) => (
            <div className="col-6" key={img.id}>
              <a
                href={`${ApiConnectionString}/api/Image/${img.id}`}
                className="lightgallery-item"
              >
                <img
                  src={`${ApiConnectionString}/api/Image/${img.id}`}
                  alt="Club"
                  className="img-fluid rounded border w-100"
                  style={{ aspectRatio: "1/1", objectFit: "cover" }}
                />
              </a>
            </div>
          ))}
        </div>
      </LightGallery>
    );
  };
  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    return (
      <div>
        <div className="container bg-white">
          <div className="row mx-4 mt-0">
            <div className="col-12 col-md-6 mt-5">
              <Dropdown>
                <Dropdown.Toggle
                  as="span"
                  id="dropdown-custom-components"
                  className="dropdown-toggle-custom"
                >
                  <div
                    className="circle-crop image-container pointer"
                    // onClick={() => club.image && setProfileImgModal(true)}
                  >
                    <img
                      src={
                        club.image
                          ? `${ApiConnectionString}/api/ClubProfileImage/${club.id}`
                          : NoImagePlaceholder
                      }
                      alt="Club Image"
                      className="mt-0"
                    />
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => club.image && setProfileImgModal(true)}
                  >
                    View
                  </Dropdown.Item>
                  {club.image ? (
                    <Dropdown.Item
                      onClick={() => {
                        setUploadProfilePicModal(true);
                      }}
                    >
                      Change Profile Picture
                    </Dropdown.Item>
                  ) : (
                    <Dropdown.Item
                      onClick={() => {
                        setUploadProfilePicModal(true);
                      }}
                    >
                      Upload Profile Picture
                    </Dropdown.Item>
                  )}
                  {club.image && (
                    <Dropdown.Item
                      onClick={() => {
                        setDeleteProfileImageModal(true);
                      }}
                    >
                      Delete Profile Picture
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>

              <p className="text-muted mb-0 mt-4">Joined {readableDate} </p>
              <p className="fontSize30 mb-0 fw-bold">{club.name}</p>
              <p>
                {club.address}, {club.city}, {club.county}, {club.postCode}
              </p>
              <div
                className="d-flex align-items-center pointer"
                onClick={() => {
                  setShowReviews(true);
                }}
              >
                {[...Array(5)].map((_, index) => {
                  if (index < fullStars) {
                    return <StarFill key={index} />;
                  } else if (index === fullStars && hasHalfStar) {
                    return <StarHalf key={index} />;
                  } else {
                    return <Star key={index} />;
                  }
                })}
                <p className="mx-2 mt-4">
                  {averageRating.toFixed(1)} • {totalReviews} reviews
                </p>
              </div>
              <hr className="mb-3 mt-0" width="50%" />
              {showReviews && (
                <Reviews rating={rating} id={id} closeReviews={closeReviews} />
              )}
              <p>{club.description}</p>
              {club.phoneNumber && (
                <div className="d-flex">
                  <div className="d-flex icon-container">
                    <TelephoneFill className="icon" />
                  </div>
                  <p className="mx-2 my-2 fw-bold">{club.phoneNumber}</p>
                </div>
              )}
              {club.email && (
                <div className="d-flex mt-2">
                  <div className="d-flex icon-container">
                    <Envelope className="icon" />
                  </div>
                  <p className="mx-2 my-2 fw-bold">{club.email}</p>
                </div>
              )}
              {club.website && (
                <div className="d-flex mt-2">
                  <div className="d-flex icon-container">
                    <BrowserEdge className="icon" />
                  </div>
                  <p className="mx-2 my-2 fw-bold">{club.website}</p>
                </div>
              )}
              <div className="my-2">
                <div className="d-flex ">
                  {club.facebook && (
                    <a href={club.facebook}>
                      <Facebook className="social-icon" />
                    </a>
                  )}
                  {club.twitter && (
                    <a href={club.twitter}>
                      <Twitter className="social-icon" />
                    </a>
                  )}
                  {club.instagram && (
                    <a href={club.instagram}>
                      <Instagram className="social-icon" />
                    </a>
                  )}
                </div>

                <div className="d-flex">
                  {club.linkedin && (
                    <a href={club.linkedin}>
                      <Linkedin className="social-icon" />
                    </a>
                  )}
                  {club.tikTok && (
                    <a href={club.tikTok}>
                      {" "}
                      <Tiktok className="social-icon" />{" "}
                    </a>
                  )}
                </div>
              </div>

              <div className="d-flex">
                <button
                  onClick={() => navi(`/editClub/${id}`)}
                  className="moc-red-button my-2 w-50"
                >
                  <a className="fw-bold">Edit Club Details</a>
                </button>
              </div>
            </div>
            <div className="col">
              {renderLayout()}
              <button
                onClick={() => navi(`/ClubImages/${id}`)}
                className="moc-red-button my-2 mx-5"
              >
                <a className="fw-bold">Manage Images</a>
              </button>
            </div>
          </div>

          <div className="nav-scroller py-1 mb-2"></div>
          {uploadProfilePictureModal && (
            <UploadProfilePictureModal
              cancelModal={cancelModal}
              id={id}
              fetchData={fetchData}
            />
          )}
          {deleteProfileImageModal && (
            <DeleteProfilePictuteModal
              cancelModal={cancelModal}
              id={id}
              fetchData={fetchData}
            />
          )}
          {profileImgModal && (
            <ProfileImgModal
              cancelModal={cancelModal}
              image={`${ApiConnectionString}/api/ClubProfileImage/${club.id}`}
            />
          )}
          {imgModal && (
            <ClubImageModal
              cancelModal={cancelModal}
              selectedIndex={selectedIndex}
              images={images}
            />
          )}
        </div>
      </div>
    );
  }
}
